import { render, staticRenderFns } from "./verifile.vue?vue&type=template&id=35e33cf1&scoped=true&"
import script from "./verifile.vue?vue&type=script&lang=js&"
export * from "./verifile.vue?vue&type=script&lang=js&"
import style0 from "./verifile.vue?vue&type=style&index=0&id=35e33cf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e33cf1",
  null
  
)

export default component.exports